module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1hsF9z/tc-custom/9781507189344.jpg?1692614730308",
      "alt": "This image is the cover for the book Uma Vida com Lobisomens"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Uma Vida com Lobisomens\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Um novo predador. Um salvador inesperado. Uma jornada dentro do desconhecido."), _c('br'), _vm._v(" Taya experimenta sua primeira transformação como um lobisomem, e é mais assustadora do que ela tinha imaginado. Colocada de volta na Reserva Blackfoot Werewolf, ela tem de lidar com olhos acusadores e um alfa bastante agressivo."), _c('br'), _vm._v(" Esta é a parte 5 de 6."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      K. Matthew, Maria Birkenhead\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("K. Matthew escreve histórias de romances fumegantes em uma variedade de gêneros. De bilionários fogosos a transformadores com apetites vorazes por seus amores curvilíneos, há alguma coisa para todos."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Babelcube\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0